export default __webpack_public_path__ + "static/media/icon-congratulations.ec0f8868.svg";